<template>
  <div class="mask" :class="getClass" v-show="$bus.toast.show" @click="hide">
    <div class="toast" ref="toast">{{ $bus.toast.content }}</div>
  </div>
</template>

<script>
import anime from '@/utils/animation'
import { addGA } from '@/utils/assist'

export default {
  data () {
    return {
      timer: null
    }
  },
  computed: {
    getClass () {
      return this.$bus.toast.closeable ? '' : 'mask-uncloseable'
    }
  },
  methods: {
    hide (e) {
      addGA('hide-toast', 'click')
      // 判断是否可以关闭
      if (this.$bus.toast.closeable) {
        const target = this.$refs.toast
        if (!target.isEqualNode(e.target) && !target.contains(e.target)) {
          this.$bus.toast.show = false

          clearTimeout(this.timer)
          this.timer = null
        }
      }
    },
    autoHide () {
      if (this.$bus.toast.closeable) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.$bus.toast.show = false

          clearTimeout(this.timer)
          this.timer = null
        }, 2000)
      }
    }
  },
  watch: {
    '$bus.toast.show': {
      handler (current) {
        if (current) {
          anime.toast(this.$refs.toast, this.autoHide)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  @include flexjc;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  @include px2res(padding-top, 156);
  z-index: 2000;

  &.mask-uncloseable {
    background-color: $opacity;
  }

  .toast {
    @include flexrc;
    @include px2res(width, 734);
    @include px2res(height, 81);
    @include px2res(border-width, 10);
    border-style: solid;
    border-image:linear-gradient(34deg, rgba(230,197,0,1), rgba(209,65,132,1)) 10 10;
    box-shadow: 0 13px 10px 0 rgba(0, 0, 0, 0.73);
    background-color: #000;
    font-weight: 300;
    @include px2res(font-size, 30);
    z-index: 200;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/toast/index.vue